import { h, Component } from 'preact';
import { ServiceWorkerSvc } from '../services/ServiceWorkerSvc';
import { AuthApiService } from '../services/authapi.service';
import { AuthService } from '../services/auth.service';
import { BuildingApiService } from '../services/buildingapi.service';
import { ModalDialog } from '../components/modalDialog/modalDialog';
import Snackbar from 'preact-material-components/Snackbar';
import { CommonService } from '../services/common.service';

export abstract class BaseComponent<TProp, TState> extends Component<TProp, TState> { 

    public swsvc: ServiceWorkerSvc;
    public authService: AuthApiService;
    public auth: AuthService;
    public buildingService: BuildingApiService;
    public modal: ModalDialog;

    public commonService: CommonService;

    public refs: any = {};

    constructor(props, ctx) {
        super(props, ctx);
        this.authService = ctx.authService;
        this.buildingService = ctx.buildingService;
        this.auth = ctx.auth;
        this.swsvc = new ServiceWorkerSvc();
        this.modal = ctx.modal;
        this.commonService = ctx.commonService;
    }

    public setRef(key: string) {
        return (val) => { (this as any).refs[key] = val };
    }    
}


// WEBPACK FOOTER //
// ./common/BaseComponent.tsx